var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClientStatus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 14L15 15.6667L18.3333 12.3333",
    fill: "#F3FDE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91667 8.16667C9.75762 8.16667 11.25 6.67428 11.25 4.83333C11.25 2.99238 9.75762 1.5 7.91667 1.5C6.07572 1.5 4.58333 2.99238 4.58333 4.83333C4.58333 6.67428 6.07572 8.16667 7.91667 8.16667Z",
    fill: "#F3FDE2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 14L15 15.6667L18.3333 12.3333M10 11.5H6.66667C5.11353 11.5 4.33696 11.5 3.72439 11.7537C2.90763 12.092 2.25872 12.741 1.9204 13.5577C1.66667 14.1703 1.66667 14.9469 1.66667 16.5M12.9167 1.7423C14.1383 2.23679 15 3.43443 15 4.83333C15 6.23224 14.1383 7.42988 12.9167 7.92437M11.25 4.83333C11.25 6.67428 9.75762 8.16667 7.91667 8.16667C6.07572 8.16667 4.58333 6.67428 4.58333 4.83333C4.58333 2.99238 6.07572 1.5 7.91667 1.5C9.75762 1.5 11.25 2.99238 11.25 4.83333Z",
    stroke: "#24352F",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientStatus);
export default __webpack_public_path__ + "static/media/client-status.c5b4af9b.svg";
export { ForwardRef as ReactComponent };